import styled from 'styled-components';

export const P = styled.p`
  text-align: left !important;
`;
